



































































































































































































































































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { Accountable, Movement, MovementActivityType, MovementType } from '@/data/models/movimento.model';
import { currencyToNumber, newDate, numberMask } from '@/data/utils/helper';
import { MovementService } from '@/data/services/movimento.service';
import store, { State } from '@/store';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class EditMovimento extends Vue {
	@Prop() movement?: Movement;

	@Inject('MovementService') movementService!: MovementService;

	newMovement!: Movement;
	income: boolean | null = null;
	accountable: Accountable | null = null;
	conto: string = '';

	activityTypes: string[] = Object.keys(MovementActivityType).map(
		// @ts-ignore
		(k: string) => MovementActivityType[k]
	);
	types = Object.keys(MovementType).map(
		// @ts-ignore
		(k: string) => MovementType[k]
	);

	numberMask: any = numberMask();
	currencies: any = {};

	accountableTerm: string = '';
	loadingAccountable: boolean = false;
	itemsAccountable: Accountable[] = [];
	_intervalRef?: any = null;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.newMovement = new Movement();
		this.newMovement.movtype = MovementType.STANDARD;
		this.newMovement.activitytype = MovementActivityType.INSTITUTIONAL;
	}

	beforeMount() {
		if (this.movement && this.movement.id) {
			this.newMovement = cloneDeep(this.movement);
			this.income = this.newMovement.isIncoming;
			this.conto = this.income ? this.newMovement.toaccount! : this.newMovement.fromaccount!;	
			this.accountableTerm = this.income ? this.newMovement.fromaccountdescr! : this.newMovement.toaccountdescr!;
			this.accountable = new Accountable();
			this.accountable.eid = this.newMovement.eid!;
			this.accountable.entity = this.newMovement.entity!;
			this.accountable.account = this.income ? this.newMovement.fromaccount! : this.newMovement.toaccount!;	
		} else {
			this.newMovement.year = newDate().getFullYear();
		}
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	onTypingAccountable(term: string) {
		if (term) {
			clearTimeout(this._intervalRef);
			this._intervalRef = setTimeout(() => {
				this.movementService
					.searchAccountable(term)
					.then((result) => {
						this.itemsAccountable = result;
					})
					.finally(() => (this.loadingAccountable = false));
			}, 500);
		} else {
			this.itemsAccountable = [];
		}
	}

	onTypeChange() {
		if (this.newMovement.movtype === MovementType.ASSOCIATE) {
			this.$set(this.newMovement, 'amount', this.state.headquarter!.defaultquota!);
		}
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.newMovement, k, this.currencies[k]);
		});
		if (this.income) {
			this.newMovement.eid = this.accountable!.eid;
			this.newMovement.entity = this.accountable!.entity;
			this.newMovement.fromaccount = this.accountable!.account;
			this.newMovement.toaccount = this.conto;
		} else {
			this.newMovement.eid = this.accountable!.eid;
			this.newMovement.entity = this.accountable!.entity;
			this.newMovement.toaccount = this.accountable!.account;
			this.newMovement.fromaccount = this.conto;
		}
		this.$emit('submit', this.newMovement);
	}

	close() {
		(this.$parent as any).close();
	}

}
